export const SHOW_OTP_EVENT = 'SHOW_OTP_EVENT';
export const CLOSE_OTP_EVENT = 'CLOSE_OTP_EVENT';
export const OTP_CLOSED_EVENT = 'OTP_CLOSED_EVENT';
export const OTP_SUCCESS_EVENT = 'OTP_SUCCESS_EVENT';

export const SHOW_TOS = 'SHOW_TOS';
export const CLOSE_TOS = 'CLOSE_TOS';

export const HANDLE_SHARED_FILE = 'HANDLE_SHARED_FILE';

export const CLAIM_PROFILE_VERIFIED = 'CLAIM_PROFILE_VERIFIED';